// extracted by mini-css-extract-plugin
module.exports = {"ButtonGroup":"LayerStatistics_ButtonGroup__1LIqu"};